<div class="row form-builder">
    <div *ngIf="formInstance?.version > 0" class="version-info">Version {{formInstance.version}}, updated by {{formInstance.modifiedBy}} on {{formInstance.modifiedDate | date: 'medium'}}</div>

    <div *ngIf="AccessLostAfterWorkflowTransition" class="access-lost">
        After changing this Form's workflow, you no longer have access to it.<br />
        <a (click)="returnToHome()" class="close-screen-link">Close this Screen</a>
    </div>

    <!-- If we have show to/hide from logic, display a list of selectable role names. -->
    <ng-container *ngIf="this.HasShowToHideFromLogic">
        <div *ngIf="!this.FormSaved">
            <p>Note:  to apply "Show To/Hide From" logic, please save the form.</p>
        </div>
        <div *ngIf="this.FormSaved"
             class="show-to-hide-from-roles-div">
            <span class="selected-role-names-span">Selected Role(s):</span>

            <mat-selection-list [(ngModel)]="this.SelectedRoleNames"
                                (ngModelChange)="this.roleSelectionChanged()"
                                class="show-to-hide-from-roles-mat-selection-list">
                <mat-list-option *ngFor="let siteRoleName of this.SiteRoleNames"
                                 [value]="siteRoleName">
                    {{siteRoleName}}
                </mat-list-option>
            </mat-selection-list>

            <div class="consume-roles-div-space"></div>
        </div>
    </ng-container>

    <ng-container *ngIf="!AccessLostAfterWorkflowTransition">
        <!-- Display form content. -->
        <div class="form-canvas">
            <mat-card appearance="outlined" class="mat-card-styling">
                <mat-card-content>
                    <div *ngFor="let row of form.formLayout.rows | filter : 'isLastRow' : 'false'; let iRow=index"
                         [ngClass]="this.getTransientSetHeightToZero(row, form, iRow) ? 'hidden-form-row form-row': 'form-row'">
                        <ng-container *ngIf="this.ShowRowContent(row)">
                            <div class="row form-canvas-row">
                                <div *ngFor="let cell of row.cells" [class]="cell.gridCssClass">
                                    <div class="layout-cell">
                                        <div *ngIf="this.ShowCellContent(cell)">
                                            <app-form-field-wrapper [formField]="getFormField(cell.formFieldId, cell.name)"
                                                                    [formInstance]="this.formInstance"
                                                                    [mode]="mode"
                                                                    [readOnly]="this.ReadOnly"
                                                                    (onInit)="this.handleOnInit($event, cell)"
                                                                    [revealValidationErrors]="this.RevealValidationErrors"
                                                                    (requestFormInstanceIds)="this.requestFormInstanceIds($event)"
                                                                    [(ngModel)]="cell.formInstanceElement"
                                                                    (ngModelChange)="this.handleNgOnFormInstanceElementChange(row, cell)"
                                                                    (loadFormInstanceElement)="this.handleLoadFormInstanceElement($event)"
                                                                    (formStatusChanged)="this.setFormValid($event)"
                                                                    (newObjectCreated)="this.handleNewObjectCreated($event)"
                                                                    (touched)="this.handleFormFieldOnBlur($event)"
                                                                    (conditionalLogicInstructions)="this.handleConditionalLogicInstructions($event)">
                                            </app-form-field-wrapper>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                    </div>

                </mat-card-content>
            </mat-card>
        </div>
        <div class="spacer">
        </div>
    </ng-container>
</div>

<!-- Define 'Save' and 'Reset' buttons. -->
<!-- TEAMS-561: KLW - Add in logic to handle if save button is enabled if there are validations  -->
<div *ngIf="(this.mode === 'instance') && (formInstance != null) && (formInstance.version == 0) && !AccessLostAfterWorkflowTransition && this.ShowSaveDiscard" class="form-buttons-div noprint">
    <div *ngIf="!this.HideSaveButton" class="form-button-div">
        <button mat-raised-button
                class="form-button-primary mat-elevation-z2"
                [disabled]="this.formButtonsDisabled || this.SaveDisabled"
                (click)="this.saveClicked()">
            {{SaveButtonCaption}}
        </button>
    </div>

    <div *ngIf="isClosable" class="form-button-div">
        <button mat-raised-button
                class="form-button mat-elevation-z2"
                [disabled]="this.formButtonsDisabled"
                (click)="this.closeClicked()">
            Close
        </button>
    </div>

    <!--VNEXT-950: KLW - Logic to show and hide the transition buttons-->
    <div *ngIf="this.ShowTransitions" class="workflow-buttons">
        <div *ngFor="let workflowTransition of this.WorkflowStateTransitions">
            <!--VNEXT-328: KLW - Added the tooltip to show the description of a transition-->
            <div class="form-button-div">
                <button mat-raised-button
                        value="{{workflowTransition.name}}"
                        matTooltip="{{workflowTransition.description}}"
                        class="form-button workflow-action-button mat-elevation-z2"
                        [disabled]="this.formButtonsDisabled || this.SaveDisabled"
                        (click)="this.workflowTransitionClicked(workflowTransition,$event)">
                    <span>{{workflowTransition.name}}<span *ngIf="workflowTransition.isCurrentState"> (Current)</span></span>
                </button>
            </div>
        </div>

        <div *ngIf="formInstance.showSendNotificationsButton" class="form-button-div">
            <button mat-raised-button
                    value="'Send Notifications'"
                    matTooltip="'Send Notifications to All Subscribers for this Form'"
                    class="form-button workflow-action-button mat-elevation-z2"
                    [disabled]="this.formButtonsDisabled || this.SaveDisabled"
                    (click)="this.sendNotificationToAllSubs($event)">
                <span>Send Notifications</span>
            </button>
        </div>
    </div>

    <div *ngIf="!this.ReadOnly" class="form-button-div" style="margin-left: 50px;">
        <button mat-raised-button
                title="Discard any edits and reload the most recent changes to this form"
                class="form-button-secondary mat-elevation-z2"
                [disabled]="this.formButtonsDisabled"
                (click)="this.resetClicked()">
            <mat-icon>refresh</mat-icon>Reload Form
        </button>
    </div>
</div>
